export default (function (_ref) {
  var Vue = _ref.Vue;

  // Ensure this only runs on the client-side/browser
  if (typeof window !== 'undefined') {
    // Suppress regular ResizeObserver layout frame loop notifications
    window.addEventListener('error', function (event) {
      if (event.message === 'ResizeObserver loop completed with undelivered notifications.' || event.message === 'ResizeObserver loop limit exceeded') {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    }); // Suppress if the framework passes it up as an unhandled rejection

    window.addEventListener('unhandledrejection', function (event) {
      var reason = event.reason && event.reason.message || event.reason;

      if (reason === 'ResizeObserver loop completed with undelivered notifications.' || reason === 'ResizeObserver loop limit exceeded') {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    });
  }
});